/* eslint-disable no-await-in-loop */
import { expect, waitUntil, aTimeout } from '@open-wc/testing';
import {
  executeServerCommand,
  sendKeys,
  sendMouse,
} from '@web/test-runner-commands';
import fetchMock from 'fetch-mock';
import '../src/testHarness.js';
import {
  apiCallKey,
  mockDataMeta,
  fixtureBeforeEach,
  fixtureBefore,
  fixtureAfterEach,
  TelemInfo,
  screenshotAndCompare,
} from './utils/helpers.js';

describe('read all notifications', () => {
  let readAllModalInfo: TelemInfo[] = [];

  before(async () => {
    await fixtureBefore();
  });

  beforeEach(async () => {
    await fixtureBeforeEach();

    await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-cta-all-read"] md-icon-button',
    });

    await sendKeys({
      press: 'Space',
    });

    await aTimeout(300);
  });

  afterEach(async () => {
    fixtureAfterEach();
  });

  it('should open, close and re-open', async () => {
    await screenshotAndCompare('read-all-modal');

    readAllModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-confirm-read-dialog"][open]',
      action: 'info',
    });

    expect(readAllModalInfo.length).to.equal(1);

    await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testid="notifications-confirm-read-dialog"][open] ix-button[name="cancel"]',
    });

    await sendKeys({
      press: 'Space',
    });

    await aTimeout(300);

    readAllModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-confirm-read-dialog"][open]',
      action: 'info',
    });

    expect(readAllModalInfo.length).to.equal(0);

    await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-cta-all-read"] md-icon-button',
    });

    await sendKeys({
      press: 'Space',
    });

    await aTimeout(300);

    readAllModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-confirm-read-dialog"][open]',
      action: 'info',
    });

    expect(readAllModalInfo.length).to.equal(1);

    // ensure it re-opens after being dismissed on a scrim click
    await sendMouse({
      type: 'click',
      position: [100, 100],
    });

    await aTimeout(300);

    readAllModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-confirm-read-dialog"][open]',
      action: 'info',
    });

    expect(readAllModalInfo.length).to.equal(0);

    await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-cta-all-read"] md-icon-button',
    });

    await sendKeys({
      press: 'Space',
    });

    await aTimeout(300);

    readAllModalInfo = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notifications-confirm-read-dialog"][open]',
      action: 'info',
    });

    expect(readAllModalInfo.length).to.equal(1);
  });

  it('should make API calls on yes click', async () => {
    let unreadIconCount: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testid="notification-unread-count"]',
        action: 'info',
      }
    );

    expect(unreadIconCount[0].text.includes('9')).to.equal(true);

    await executeServerCommand('mouseFocusInfo', {
      selector:
        '[data-testid="notifications-confirm-read-dialog"][open] ix-button[name="confirm"]',
    });

    await sendKeys({
      press: 'Space',
    });

    await waitUntil(
      () => {
        const calls = fetchMock.callHistory.calls(apiCallKey);
        const patchCalls = calls.filter(
          call => call.options.method === 'patch'
        );
        return patchCalls.length > 0;
      },
      `${apiCallKey} API PATCH call was not made`,
      { interval: 10, timeout: 20000 }
    );

    const readItemsInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: 'notification-item[read]',
        action: 'info',
      }
    );

    expect(readItemsInfo.length).to.equal(mockDataMeta.itemsCount);

    const unreadItemsInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: 'notification-item[unread]',
        action: 'info',
      }
    );

    expect(unreadItemsInfo.length).to.equal(0);

    const messageInfo: TelemInfo[] = await executeServerCommand(
      'mouseFocusInfo',
      {
        selector: '[data-testid="notification-read-all-toast"]',
        action: 'info',
      }
    );

    expect(messageInfo[0].text.includes('Successfully marked')).to.equal(true);

    unreadIconCount = await executeServerCommand('mouseFocusInfo', {
      selector: '[data-testid="notification-unread-count"]',
      action: 'info',
    });

    expect(unreadIconCount[0]).to.equal(undefined);

    await screenshotAndCompare('read-all-items');
  });
});
